import { render, staticRenderFns } from "./PackExcels.vue?vue&type=template&id=168504c8"
import script from "./PackExcels.vue?vue&type=script&lang=js"
export * from "./PackExcels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports